import { formatRawPhoneNumber } from '../../phoneExpenses/utils/formatPhone';

export const CALL_STATUS_LABEL = {
  RINGING: 'Дзвонить',
  ANSWERED: 'Розмова',
  COMPLETED: 'Завершено',
  MISSED: 'Пропущений',
};

/** Причини відмітки «помилковий дзвінок» (ключі = enum бекенду, falseReason). */
export const FALSE_REASON_LABEL = {
  SPAM: 'Спам',
  WRONG_NUMBER: 'Помилковий номер',
  NO_ACTION_REQUIRED: 'Не потребує обробки',
  OTHER: 'Інше',
};

export const CALL_STATUS_COLOR = {
  RINGING: { color: 'var(--spark-color-warning-text)', bg: 'var(--spark-color-warning-surface)' },
  ANSWERED: { color: 'var(--spark-color-success-text)', bg: 'var(--spark-color-success-surface)' },
  COMPLETED: { color: 'var(--spark-color-text-muted)', bg: 'var(--spark-color-surface-muted)' },
  MISSED: { color: 'var(--spark-color-error-text)', bg: 'var(--spark-color-error-surface)' },
};

/** Номер абонента як прийшов з PBX → 097 322 00 44 */
export function formatCallerNumber(raw) {
  if (!raw) return 'Приховано';
  return formatRawPhoneNumber(raw) || raw;
}

/** DID лінії (9 нормалізованих цифр) → 095 694 49 20 */
export function formatDid(did) {
  if (!did) return '';
  return formatRawPhoneNumber(`0${did}`) || did;
}

/** «Куди дзвонили»: 095 694 49 20 · Назва лінії з довідника */
export function formatLine(line, did) {
  const number = formatDid(line?.did || did);
  const name = line?.name;
  if (number && name && name !== number) return `${number} · ${name}`;
  return number || name || '';
}

export function formatDuration(sec) {
  if (sec == null) return '';
  const s = Math.max(0, Math.floor(sec));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

export function formatDateTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return `${d.toLocaleDateString('uk-UA', { day: '2-digit', month: '2-digit', year: 'numeric' })} ${d.toLocaleTimeString('uk-UA', { hour: '2-digit', minute: '2-digit' })}`;
}

export function formatDateShort(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return `${d.toLocaleDateString('uk-UA', { day: '2-digit', month: '2-digit' })} ${d.toLocaleTimeString('uk-UA', { hour: '2-digit', minute: '2-digit' })}`;
}

export function userName(u) {
  if (!u) return '';
  return [u.lastName, u.firstName].filter(Boolean).join(' ') || u.authEmail || '';
}
